import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTraffic = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M15.5158 12.2656C15.5158 11.7133 15.0681 11.2656 14.5158 11.2656H3C2.44771 11.2656 2 11.7133 2 12.2656V17.3038C2 17.8561 2.44771 18.3038 3 18.3038H14.5158C15.0681 18.3038 15.5158 17.8561 15.5158 17.3038V12.2656ZM13.5158 13.2656V16.3038H4V13.2656H13.5158Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M14.0048 8.29554C13.853 7.91588 13.4853 7.66693 13.0764 7.66693H4.43948C4.03057 7.66693 3.66286 7.91588 3.511 8.29554L2.07152 11.8942C1.94828 12.2023 1.9859 12.5515 2.17193 12.8263C2.35796 13.101 2.66817 13.2656 3 13.2656H14.5158C14.8477 13.2656 15.1579 13.101 15.3439 12.8263C15.5299 12.5515 15.5675 12.2023 15.4443 11.8942L14.0048 8.29554ZM12.3993 9.66693L13.0388 11.2656H4.47703L5.11651 9.66693H12.3993Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M1.9953 16.7735V18.7433C1.9953 19.4336 2.55494 19.9933 3.2453 19.9933C3.93566 19.9933 4.4953 19.4336 4.4953 18.7433V16.7735H1.9953Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M13.0152 16.7735V18.7433C13.0152 19.4336 13.5749 19.9933 14.2652 19.9933C14.9556 19.9933 15.5152 19.4336 15.5152 18.7433V16.7735H13.0152Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.9171 14.7847C10.9171 15.381 11.4005 15.8643 11.9967 15.8643C12.593 15.8643 13.0764 15.381 13.0764 14.7847C13.0764 14.1885 12.593 13.7051 11.9967 13.7051C11.4005 13.7051 10.9171 14.1885 10.9171 14.7847Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.43948 14.7847C4.43948 15.381 4.92283 15.8643 5.51908 15.8643C6.11534 15.8643 6.59869 15.381 6.59869 14.7847C6.59869 14.1885 6.11534 13.7051 5.51908 13.7051C4.92283 13.7051 4.43948 14.1885 4.43948 14.7847Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M17.2357 5.45991C17.084 5.07996 16.7161 4.83075 16.307 4.83075H7.67013C7.26122 4.83075 6.89351 5.0797 6.74165 5.45936L6.02148 7.25979L5.76539 7.90217C5.58721 8.34913 5.7526 8.85962 6.15903 9.11717L6.79253 9.5186C6.95293 9.62025 7.13896 9.67412 7.32886 9.67392L12.3999 9.6685L12.4557 9.80314L13.5154 12.5346V14.4738C13.5154 15.026 13.9631 15.4738 14.5154 15.4738H16.7465V15.9132C16.7465 16.4655 17.1942 16.9132 17.7465 16.9132C18.2987 16.9132 18.7465 16.4655 18.7465 15.9132V9.43558C18.7465 9.30856 18.7223 9.1827 18.6752 9.06474L17.2357 5.45991ZM16.7465 13.4738H15.5154V12.3474C15.5154 12.2237 15.4924 12.101 15.4477 11.9857L14.8451 10.4324L16.7465 10.4345V13.4738ZM16.2697 8.43396L14.0522 8.43152L13.9914 8.28486C13.8364 7.91096 13.4713 7.66736 13.0665 7.66779L8.01018 7.67319L8.34716 6.83075H15.6295L16.2697 8.43396Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.1478 11.9547C14.1478 12.5509 14.6311 13.0343 15.2274 13.0343C15.8236 13.0343 16.307 12.5509 16.307 11.9547C16.307 11.3584 15.8236 10.8751 15.2274 10.8751C14.6311 10.8751 14.1478 11.3584 14.1478 11.9547Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M20.4663 2.63599C20.3146 2.25605 19.9467 2.00684 19.5376 2.00684H10.9007C10.4918 2.00684 10.1241 2.25579 9.97227 2.63545L9.2521 4.43587L8.99601 5.07826C8.81783 5.52522 8.98322 6.0357 9.38965 6.29325L10.0231 6.69469C10.1836 6.79634 10.3696 6.85021 10.5595 6.85L15.6305 6.84459L15.6863 6.97922L16.746 9.71064V11.6498C16.746 12.2021 17.1937 12.6498 17.746 12.6498H19.9771V13.0893C19.9771 13.6416 20.4248 14.0893 20.9771 14.0893C21.5294 14.0893 21.9771 13.6416 21.9771 13.0893V6.61167C21.9771 6.48465 21.9529 6.35879 21.9058 6.24082L20.4663 2.63599ZM19.9771 10.6498H18.746V9.52346C18.746 9.39975 18.723 9.27711 18.6783 9.16177L18.0757 7.60848L19.9771 7.61057V10.6498ZM19.5003 5.61004L17.2828 5.60761L17.222 5.46095C17.067 5.08704 16.7019 4.84344 16.2971 4.84387L11.2408 4.84928L11.5778 4.00684H18.8602L19.5003 5.61004Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M18.458 9.21037C18.414 9.21037 18.3784 9.17472 18.3784 9.13076C18.3784 9.08679 18.414 9.05115 18.458 9.05115C18.502 9.05115 18.5376 9.08679 18.5376 9.13076C18.5376 9.17472 18.502 9.21037 18.458 9.21037ZM18.458 10.2104C17.8617 10.2104 17.3784 9.72701 17.3784 9.13076C17.3784 8.5345 17.8617 8.05115 18.458 8.05115C19.0542 8.05115 19.5376 8.5345 19.5376 9.13076C19.5376 9.72701 19.0542 10.2104 18.458 10.2104Z",
			fill: "currentColor"
		})
	]
});
export default SvgTraffic;
